module.exports = __webpack_public_path__ + "static/media/TN5.c31f33a6.jpg";